import * as React from 'react';

import { Row, Block, Col } from 'emotion-jsxstyle';
import { SidebarGroup } from './SidebarGroup';

import { AppState } from 'common/models/AppState';
import { Member } from 'common/api/models/Member';
import { UserPermissions } from 'common/api/models/UserPermissions';
import Media from 'react-media';

// Generated at build time
const RELEASE_NOTES_META = require('../../../../screens/ReleaseNotes/RELEASE_NOTES_META.json');

interface SidebarProps {
  currentUser: Member;
  onClose: () => void;
  isOpen: boolean;
  appState: AppState;
}

interface SidebarState {
  current: string;
}

const SIDEBAR_ITEMS = [
  {
    name: 'Members',

    kids: [
      {
        name: 'Users',
        link: {
          pathname: '/users',
          search: '?q=status:active',
        },
        iconName: 'users',
        enabled: true,
      },
      {
        name: 'Organizations',
        link: {
          pathname: '/orgs',
          search: '?q=status:active',
        },
        iconName: 'building',
        enabled: true,
        blockAdminType: UserPermissions.Permissions.CHAPTERSADMIN,
      },
      {
        name: 'Chapters',
        link: '/chapters',
        iconName: 'leaf',
        enabled: true,
      },
      // {
      //   name: 'Notes',
      //   link: '/notes',
      //   iconName: 'file-text-o',
      // },
      // {
      //   name: 'Awards',
      //   link: '/awards',
      //   iconName: 'trophy',
      // },
    ],
  },
  // {
  //   name: 'Applications',

  //   kids: [
  //     {
  //       name: 'CEU',
  //       iconName: 'graduation-cap',
  //       link: '/ceu',
  //     },
  //     {
  //       name: 'Certification',
  //       iconName: 'certificate',
  //       link: '/certification',
  //     },
  //     {
  //       name: 'Accreditations',
  //       link: '/accreditations',
  //       iconName: 'university',
  //     },
  //   ],
  // },
  {
    name: 'Billing',
    blockAdminType: UserPermissions.Permissions.CHAPTERSADMIN,
    kids: [
      {
        name: 'Products',
        iconName: 'barcode',
        link: '/products',
        enabled: true,
      },
      {
        name: 'Orders',
        iconName: 'shopping-cart',
        link: '/orders',
        enabled: true,
      },
      {
        name: 'WooCommerce Orders',
        iconName: 'shopping-cart',
        link: '',
        enabled: true,
        externalLink: process.env.REACT_APP_WP_URL + '/wp-admin/edit.php?post_type=shop_order',
      },
      {
        name: 'Legacy WooCommerce Orders',
        iconName: 'shopping-cart',
        link: '',
        enabled: true,
        externalLink: process.env.REACT_APP_LEGACY_WP_URL + '/wp-admin/edit.php?post_type=shop_order',
      },
      // {
      //   name: 'Subscriptions',
      //   iconName: 'dollar',
      //   link: '/subscriptions',
      // },
      {
        name: 'Transactions',
        iconName: 'bank',
        link: '/transactions',
        enabled: true,
      },
      {
        name: 'Exports',
        iconName: 'cloud-download',
        link: '/exports',
        enabled: true,
        permission: UserPermissions.Permissions.ADMIN,
      },
    ],
  },
  {
    name: 'Reports',
    blockAdminType: UserPermissions.Permissions.CHAPTERSADMIN,
    kids: [
      {
        name: 'AR Aging',
        iconName: 'calendar',
        link: '/reports/aging',
        enabled: true,
      },
    ],
  },
  {
    name: 'Events',
    blockAdminType: UserPermissions.Permissions.CHAPTERSADMIN,
    kids: [
      {
        name: 'VFTI Registrants',
        iconName: 'users',
        link: '/vftiregistrants',
        enabled: true,
      },
      {
        name: 'Summit Registrants',
        iconName: 'users',
        link: '/summitregistrants',
        enabled: true,
      },
    ],
  },
  {
    name: 'System',
    blockAdminType: UserPermissions.Permissions.CHAPTERSADMIN,
    kids: [
      {
        name: 'Tags',
        iconName: 'tags',
        link: '/tags',
        enabled: true,
      },
      // {
      //   name: 'Redirects',
      //   link: '/redirects',
      //   iconName: 'sitemap',
      // },
      {
        name: (user: Member) => {
          const maybeViewedIt = window.localStorage.getItem('lastReleaseNoteViewDate');
          const releaseNotesCount = RELEASE_NOTES_META.filter(
            (d: string) => new Date(d) > new Date(maybeViewedIt === null ? user.loginAt! : maybeViewedIt)
          ).length;
          return (
            <Row component="span" alignItems="center">
              <Block component="span">Release Notes </Block>
              {releaseNotesCount > 0 && (
                <Block
                  component="span"
                  backgroundColor="#2eafff"
                  textAlign="center"
                  width={releaseNotesCount > 9 ? 20 : 16}
                  borderRadius="20px"
                  marginTop=".1rem"
                  marginLeft=".3rem"
                  fontSize={10}
                  color="#fff"
                >
                  {releaseNotesCount}
                </Block>
              )}
            </Row>
          );
        },
        iconName: 'bullhorn',
        link: '/release-notes',
        enabled: true,
      },
      {
        name: 'Config',
        iconName: 'cogs',
        link: '/config',
        enabled: true,
        permission: UserPermissions.Permissions.SUPERUSER,
      },
    ],
  },
];
export class Sidebar extends React.Component<SidebarProps, SidebarState> {
  state = {
    current: '/dashbord',
  };

  handleMouseOver = () => {
    // Yay imperative code!
    document.body.style.overflowY = 'hidden';
  };

  handleMouseOut = () => {
    document.body.style.overflowY = 'auto';
  };

  render() {
    return (
      <Media query="(min-width: 1920px)">
        {(match: boolean) => (
          <Block
            component="aside"
            transform={`translate3d(${!match ? (this.props.isOpen ? '100%' : 0) : '240px'},0,0)`}
            transition={!match && 'all .25s ease-out'}
            background={'#f1f5f9'}
            position="fixed"
            top="0"
            left="0"
            paddingLeft={match ? 16 : 0}
            zIndex="100"
            float="left"
            width={this.props.isOpen ? 256 : '240px'}
            minWidth={this.props.isOpen ? 256 : '240px'}
            marginLeft={this.props.isOpen ? -256 : '-100%'}
            height="100%"
            overflow="hidden"
            props={{
              onMouseOver: this.handleMouseOver,
              onMouseOut: this.handleMouseOut,
              tabIndex: this.props.isOpen ? -1 : undefined,
            }}
          >
            <Col
              position="relative"
              top="0"
              bottom="0"
              left="0"
              right="0"
              height="100%"
              overflowX="hidden"
              width={240}
              minWidth={240}
              props={{ role: 'navigation' }}
            >
              <Col
                overflowX="hidden"
                overflowY="scroll"
                WebkitOverflowScrolling="touch"
                position="absolute"
                width={240}
                height="100%"
                justifyContent="space-between"
                minWidth={240}
              >
                <Block paddingTop={56} marginTop="2.25rem" marginLeft={match ? '.75rem' : 0} position="relative">
                  {SIDEBAR_ITEMS.map(item => {
                    if (item.blockAdminType === this.props.currentUser.adminAccess) {
                      return <></>;
                    }
                    return (
                      <SidebarGroup
                        key={`sidebar--${item.name}`}
                        kids={item.kids}
                        name={item.name}
                        appState={this.props.appState}
                        viewer={this.props.currentUser}
                        onClose={this.props.onClose}
                      />
                    );
                  })}
                </Block>
                {/*<Block posotion="absolute" bottom="0">
                  <Block height={50} width={240}>
                    <Block paddingLeft="1rem" component={Link} color="#aaa" props={{ to: '/settings' }}>
                      <i className="fa fa-gear" /> Settings
                    </Block>
                  </Block>
                </Block>*/}
              </Col>
            </Col>
          </Block>
        )}
      </Media>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/layout/Navigator/Sidebar.tsx